import { Component, OnInit } from '@angular/core';
import { ContactData } from 'src/app/interfaces/contactData';
import { ContactsService } from 'src/app/service/contacts.service';
@Component({
  selector: 'app-share-cont-comp',
  templateUrl: './share-cont-comp.component.html',
  styleUrls: ['./share-cont-comp.component.scss']
})
export class ShareContCompComponent implements OnInit {
  contact3: ContactData = {};
  value3:string = "";
  contacts: ContactData[] = [];
  constructor(private contactsService: ContactsService) { }
  ngOnInit(): void {
    this.contactsService.getContacts().then(data => this.contacts = data);
  }

}
